import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, from } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { ProjectService } from 'app/core/services/project.service';
import * as ProjectsActions from './projects.actions';
import * as PricingActions from '../pricing/pricing.actions';
@Injectable()
export class ProjectsEffects {
  loadProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.loadProjects),
      mergeMap(() =>
        from(this.projectService.getProjects()).pipe(
          map((projects) => ProjectsActions.loadProjectsSuccess({ projects })),
          catchError((error) => of(ProjectsActions.loadProjectsFailure({ error: error.message }))),
        ),
      ),
    ),
  );

  createProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectsActions.createProject),
      mergeMap(({ projectData }) =>
        from(this.projectService.createProject(projectData)).pipe(
          map((project) => [ProjectsActions.createProjectSuccess({ project }), ProjectsActions.loadProjects(), PricingActions.loadPricingInfo()]),
          catchError((error) => of([ProjectsActions.createProjectFailure({ error: error.message })])),
        ),
      ),
      mergeMap((actions) => actions),
    ),
  );

  constructor(
    private actions$: Actions,
    private projectService: ProjectService,
  ) {}
}
